import React from 'react'
import { Translation } from 'react-i18next'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableHead,
  LinearProgress,
  Snackbar,
  Tooltip
} from '@material-ui/core'
import PushPinIcon from '@mui/icons-material/PushPin'
import PreviewOpenForWorkProfile from '../../openforwork/previewOpenForWorkProfile.component'
import AssignmentDetails from '../../openforwork/assignmentDetails.component'
import {
  contractFormKeys,
  convertPortfolioNameLinksToObject,
  convertToObjects,
  createLinkArray,
  filterKeys,
  generateProfileRatingsToObject,
  rearrangeByPinned,
  summaryRatings
} from '../../../utils/openForWork.utils'
import DialogBox from '../../../utils/employer/dialogComponent.utils'
import { useDispatch, useSelector } from 'react-redux'
import { resetForm, updateFormValues } from '../../../form'
import ContractFormComponent from '../lightEntrepreneurs/contractForm.component'
import SignatureCanvas from 'react-signature-canvas'
import { MySnackbarContentWrapper } from '../../../utils/snackbar.utils'
import FontAwesome from 'react-fontawesome'
import { CloseIcon } from '../../openforwork/closeIcon.component'
import mobileView from '../../../utils/mobile.utils'
import moment from 'moment'
import { assignmentRows } from '../../../selectors/employer/assignments.selector'
import { lightEntre } from '../../../selectors/employer/lightEntrepreneurs.selector'
import { industryRender } from '../../../utils/showIndustry.utils'
import { groupLightEntrepreneurByUuid } from '../../../utils/employer/lightEntrepreneurs.utils'

/**
 *
 * @author Huong Nguyen
 */
const styles = () => ({
  tablecell: {
    fontSize: '12px'
  },
  previewLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080'
  },
  previewValue: {
    fontWeight: 500
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  previewField: {
    minHeight: '70px'
  }
})

const ApplicationRow = ({
  t,
  index,
  classes,
  application,
  rejectWarning,
  cancelOffer,
  rejectApplication,
  showRejectWarning,
  updateViewApplication,
  updateReviewApplication,
  offerAssignment,
  isOffer,
  completeOfferForm,
  offerToPerson,
  isCompleteForm,
  isEditAssignment,
  copyPreviousAssignment,
  // applicationsSaveAssignment,
  openWarningCloseCompleteOfferForm,
  closeWarningCloseCompleteOfferForm,
  openWarningCloseCompleteForm,
  pinApplication,
  // showPdfDialog,
  signSendContract,
  signAssignmentPad,
  signPad,
  selectedOfferedData,
  closeSignContractScreen,
  loadSignAndSend,
  showSnackbar,
  showFailedSnackbar,
  closeApplicationSnackbar,
  isSigned,
  previewContract,
  enableSendOrSignButton,
  showLeItemLoader,
  areaOfWorkDict,
  companyProfile
}) => {
  const label = { inputProps: { 'aria-label': 'Switch demo' } }

  const dispatch = useDispatch()

  const [selectedApplication, setSelectedApplication] = React.useState(null)
  const [selectedAssignment, setSelectedAssignment] = React.useState(null)
  const assignments = useSelector(assignmentRows)
  const lightEntrepreneurs = groupLightEntrepreneurByUuid(
    useSelector(lightEntre)
  )
  const lightEntreList = lightEntrepreneurs.map((obj) => ({
    email: obj.email,
    firstname: obj.firstname,
    lastname: obj.lastname,
    pinned_fav_lightentrepreneur: obj.pinned_fav_lightentrepreneur
  }))

  const assignmentTypeMap = {
    until_further_notice: t('employer.assignmentType.1'),
    'until further notice': t('employer.assignmentType.1'),
    temporary: t('employer.assignmentType.2'),
    'temporary with a notice period': t('employer.assignmentType.3'),
    temporary_with_notice: t('employer.assignmentType.3'),
    until_completion: t('employer.assignmentType.4'),
    'so far until completion': t('employer.assignmentType.4')
  }

  const salaryModelMap = {
    hourly_rate: t('employer.salaryModel.1'),
    'hourly rate': t('employer.salaryModel.1'),
    contract_price: t('employer.salaryModel.2'),
    'contract price': t('employer.salaryModel.2'),
    unit_price: t('employer.salaryModel.3'),
    'unit price': t('employer.salaryModel.3'),
    commission: t('employer.salaryModel.4'),
    commission: t('employer.salaryModel.4')
  }

  // Normalize input by lowercasing and trimming spaces
  const normalizeKey = (key) => key?.toLowerCase().trim().replace(/\s+/g, ' ')

  const assignmentType =
    assignmentTypeMap[normalizeKey(selectedAssignment?.assignment_type)] || ''
  const salaryModel =
    salaryModelMap[normalizeKey(selectedAssignment?.salary_model)] || ''

  const userProfile = useSelector((state) =>
    state.lightEntrepreneurs.lightEntre.find(
      (x) => x.email === selectedApplication?.offered_entrepreneur_email
    )
  )
  const [expand, setExpand] = React.useState(false)
  const handleExpandClick = () => {
    setExpand((prevExpand) => !prevExpand)
  }

  const [isPreview, setIsPreview] = React.useState(false)
  const handlePreview = () => {
    setIsPreview(true)
  }
  const [copyPrevious, setCopyPrevious] = React.useState(false)
  const handleSwitchChange = () => {
    setCopyPrevious((prevValue) => !prevValue)

    if (!copyPrevious) {
      copyPreviousAssignment()
    } else {
      dispatch(resetForm('contractForm'))
    }
  }

  const status = selectedApplication?.agreement_id
    ? selectedApplication?.agreement_status_entrepreneur
    : selectedApplication?.application_status
  const statusOffer =
    status === 'Unprocessed application'
      ? 1
      : status === 'Offer sent by employer'
      ? 2
      : status === 'Employer rejected'
      ? 3
      : status === 'Offer accepted by entrepreneur'
      ? 4
      : status === 'Offer rejected by entrepreneur'
      ? 5
      : status === 'Offer signed'
      ? 7
      : status === 'pending'
      ? 6
      : ''

  // Personer data to send offer
  const personerData = {
    uuid: selectedApplication?.applied_person_uuid,
    appID: selectedApplication?.application_id,
    appJobID: selectedApplication?.applied_job_id,
    email: selectedApplication?.email,
    fullname:
      selectedApplication?.firstname + ' ' + selectedApplication?.lastname,
    zipCode: selectedApplication?.zip_code,
    city: selectedApplication?.city,
    info_consent_allowed: selectedApplication?.info_consent_allowed
  }

  const newApplications = application.applications.filter(
    (app) => app.isapplication_reviewed === 'no'
  ).length

  const isOfferSignedNew = application.applications.filter(
    (app) =>
      app.is_contract_viewed === 0 &&
      app.agreement_status_entrepreneur === 'Offer accepted by entrepreneur'
  ).length

  // Take only needed keys to update contract form
  const applicantDataCopy_filtered = filterKeys(
    applicantDataFormat(selectedApplication),
    contractFormKeys
  )

  React.useEffect(() => {
    if (
      !isEditAssignment &&
      isCompleteForm &&
      offerToPerson.appID === selectedApplication?.application_id
    ) {
      dispatch(updateFormValues('contractForm', applicantDataCopy_filtered))
    }
  }, [
    isEditAssignment,
    isCompleteForm,
    offerToPerson,
    selectedApplication?.application_id
  ])

  const applicationRows = rearrangeByPinned(
    application.applications,
    'pinned_applicant'
  )

  // Clear react sign canvas
  const signPadRef = React.useRef(null)
  const clear = () => {
    signPadRef.current.clear()
  }
  // Data URL - sign picture
  const [trimmedDataURL, setTrimmedDataURL] = React.useState(null)
  const trim = () => {
    if (signPadRef.current) {
      const trimmedCanvas = signPadRef.current.getTrimmedCanvas()
      if (trimmedCanvas.width !== 1 && trimmedCanvas.height !== 1) {
        setTrimmedDataURL(trimmedCanvas.toDataURL('image/png'))
      } else {
        setTrimmedDataURL(null)
      }
    }
  }

  React.useEffect(() => {
    if (trimmedDataURL) {
      signSendContract(trimmedDataURL, false, selectedOfferedData, false)
    }
  }, [trimmedDataURL])

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <TableRow
              style={{
                background: index % 2 ? 'white' : '#ebf9fa',
                cursor: 'pointer'
              }}
              onClick={() => {
                handleExpandClick()
              }}
            >
              <TableCell className={classes.tablecell}>
                <u
                  onClick={(e) => {
                    e.stopPropagation()
                    const selected = assignments.find(
                      (el) => el.assignment_id === application.applied_job_id
                    )
                    setSelectedAssignment(selected)
                  }}
                >
                  {application.job_title}
                </u>
                {isOfferSignedNew > 0 && (
                  <span
                    style={{
                      fontSize: '20px',
                      color: '#F67131'
                    }}
                  >
                    {' '}
                    •
                  </span>
                )}
              </TableCell>
              <TableCell className={classes.tablecell} style={{ width: '20%' }}>
                {moment(application.assignment_begins).format('DD.MM.YYYY')}
              </TableCell>
              <TableCell className={classes.tablecell} style={{ width: '20%' }}>
                {application.applications.length}{' '}
                {application.applications.length > 1
                  ? t('employer.app.items')
                  : t('employer.app.item')}{' '}
                {newApplications > 0 && (
                  <span style={{ color: '#F67131' }}>
                    ({newApplications} {t('employer.app.new2')})
                  </span>
                )}
              </TableCell>
              <TableCell className={classes.tablecell} style={{ width: '5%' }}>
                <div className="pull-right">
                  <IconButton aria-label="expand row" size="small">
                    {expand ? (
                      <KeyboardArrowUp fontSize="large" />
                    ) : (
                      <KeyboardArrowDown fontSize="large" />
                    )}
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
            {expand && (
              <>
                <TableRow>
                  <TableCell colSpan={4}>
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.tablecell}>
                              {t('employer.app.fld1')}
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              {t('employer.app.fld2')}
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              {t('employer.app.col7')}
                            </TableCell>
                            <TableCell
                              className={classes.tablecell}
                              colSpan={2}
                            >
                              {t('employer.app.fld8')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {applicationRows.map((app) => {
                            const status = app?.agreement_id
                              ? app.agreement_status_entrepreneur
                              : app.application_status
                            const statusOffer =
                              status === 'Unprocessed application'
                                ? 1
                                : status === 'Offer sent by employer'
                                ? 2
                                : status === 'Employer rejected'
                                ? 3
                                : status === 'Offer accepted by entrepreneur'
                                ? 4
                                : status === 'Offer rejected by entrepreneur'
                                ? 5
                                : status === 'Offer signed'
                                ? 7
                                : status === 'pending'
                                ? 6
                                : ''

                            const newNotification =
                              app.agreement_status_entrepreneur ===
                                'Offer accepted by entrepreneur' &&
                              app.is_contract_viewed === 0
                            return (
                              <TableRow key={app.application_id}>
                                <TableCell className={classes.tablecell}>
                                  <u
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      setSelectedApplication(app)
                                      app.isapplication_reviewed === 'no' &&
                                        updateReviewApplication(
                                          app.applied_person_uuid,
                                          app.application_id,
                                          app.applied_job_id
                                        )
                                      newNotification &&
                                        updateViewApplication(app.agreement_id)
                                    }}
                                  >
                                    {app.firstname} {app.lastname}
                                  </u>
                                </TableCell>
                                <TableCell className={classes.tablecell}>
                                  {app?.agreement_id
                                    ? app.offered_entrepreneur_email
                                    : app.email}
                                </TableCell>
                                <TableCell
                                  className={classes.tablecell}
                                  style={{ width: '20%' }}
                                >
                                  {moment(app?.assignment_begins).format(
                                    'DD.MM.YYYY'
                                  )}
                                </TableCell>
                                <TableCell
                                  className={classes.tablecell}
                                  style={{ width: '20%' }}
                                >
                                  {app.isapplication_reviewed === 'no' ? (
                                    <>
                                      {t(
                                        `employer.application_stt.${statusOffer}`
                                      ) + t('employer.app.new')}{' '}
                                      <span
                                        style={{
                                          fontSize: '20px',
                                          color: '#F67131'
                                        }}
                                      >
                                        •
                                      </span>
                                    </>
                                  ) : newNotification ? (
                                    <>
                                      {t(
                                        `employer.application_stt.${statusOffer}`
                                      )}{' '}
                                      <span
                                        style={{
                                          fontSize: '20px',
                                          color: '#F67131'
                                        }}
                                      >
                                        •
                                      </span>
                                    </>
                                  ) : (
                                    t(`employer.application_stt.${statusOffer}`)
                                  )}
                                </TableCell>
                                <TableCell
                                  className={classes.tablecell}
                                  style={{ width: '5%' }}
                                >
                                  <div
                                    className="pull-right"
                                    style={{ display: 'flex' }}
                                  >
                                    {statusOffer !== 1 && statusOffer !== 3 ? (
                                      <a href={app?.contract_path}>
                                        <FontAwesome name="file-pdf-o" />
                                      </a>
                                    ) : (
                                      ''
                                    )}
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      style={
                                        app.pinned_applicant ||
                                        app.pinned_application
                                          ? { color: '#F67131' }
                                          : {}
                                      }
                                      onClick={() => {
                                        pinApplication(
                                          app.application_id,
                                          app.agreement_id
                                        )
                                      }}
                                    >
                                      <PushPinIcon />
                                    </IconButton>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </TableCell>
                </TableRow>
                <Dialog
                  open={selectedApplication !== null}
                  onClose={() => setSelectedApplication(null)}
                  fullWidth={!!selectedApplication?.application_id}
                  maxWidth="md"
                >
                  <CloseIcon
                    fontSize="large"
                    onClick={() => setSelectedApplication(null)}
                  />
                  <DialogTitle
                    id="alert-dialog-title"
                    style={
                      selectedApplication?.application_id
                        ? {}
                        : { padding: '0px 20px 0px 20px' }
                    }
                  >
                    <div
                      style={{
                        textAlign: 'center',
                        color: '#000000',
                        fontSize: '15px'
                      }}
                    >
                      {t('employer.app.dialogTitle3')}
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <div>
                      {selectedApplication?.application_id ? (
                        <PreviewOpenForWorkProfile
                          t={t}
                          classes={classes}
                          profile_pic={selectedApplication?.profile_image_path}
                          // portfolios={selectedApplication?.portfolios}
                          AreaOf_Expertise={
                            selectedApplication?.area_of_expertise &&
                            selectedApplication?.area_of_expertise
                              .split(',')
                              .map((num) => Number(num.trim()))
                          }
                          role_title={selectedApplication?.title}
                          short_des={selectedApplication?.short_description}
                          portfolios={convertToObjects(
                            selectedApplication?.merged_filepaths
                          )}
                          inputCV={selectedApplication?.cv_path} // CV path
                          CV_file={selectedApplication?.cv_filename} // CV file name
                          linkRow={convertPortfolioNameLinksToObject(
                            selectedApplication?.portfolio_name_link
                          )}
                          work_experience={selectedApplication?.work_experience}
                          applicant_name={
                            selectedApplication?.firstname +
                            ' ' +
                            selectedApplication?.lastname
                          }
                          applicant_email={
                            selectedApplication?.agreement_id
                              ? selectedApplication?.offered_entrepreneur_email
                              : selectedApplication?.email
                          }
                          applicant_phone_no={selectedApplication?.phone}
                          applicant_address={
                            selectedApplication?.applicant_address
                          }
                          applicant_zipcode={
                            selectedApplication?.applicant_zipcode
                          }
                          applicant_city={selectedApplication?.applicant_city}
                          ratingsByCompany={generateProfileRatingsToObject(
                            selectedApplication?.profile_rating
                          )}
                          ratingsSummary={
                            selectedApplication?.profile_rating !== null &&
                            selectedApplication?.profile_rating !== undefined
                              ? summaryRatings(
                                  generateProfileRatingsToObject(
                                    selectedApplication?.profile_rating
                                  )
                                )
                              : null
                          }
                        />
                      ) : (
                        <PreviewOpenForWorkProfile
                          t={t}
                          classes={classes}
                          userData={userProfile}
                          profile_pic={userProfile?.user_profile_path}
                          AreaOf_Expertise={
                            userProfile?.AreaOfExpertise &&
                            userProfile?.AreaOfExpertise.split(',').map((num) =>
                              Number(num.trim())
                            )
                          }
                          role_title={userProfile?.Title}
                          short_des={userProfile?.ShortDescription}
                          portfolios={convertToObjects(
                            userProfile?.user_portfolio_path
                          )}
                          inputCV={userProfile?.user_cv_path} // CV path
                          CV_file={userProfile?.user_cv_title} // CV file name
                          linkRow={createLinkArray(
                            userProfile?.merged_porttitles !== null &&
                              userProfile?.merged_porttitles !== undefined
                              ? userProfile.merged_porttitles
                              : '',
                            userProfile?.merged_urls !== null &&
                              userProfile?.merged_urls !== undefined
                              ? userProfile?.merged_urls
                              : ''
                          )}
                          experienceInputRow={[
                            {
                              JobTitle: userProfile?.JobTitle,
                              Responsibilities: userProfile?.Responsibilities,
                              KeyAchievements: userProfile?.KeyAchievements,
                              CompanyName: userProfile?.CompanyName,
                              EndDate: userProfile?.EndDate,
                              Location: userProfile?.Location,
                              StartDat: userProfile?.StartDate
                            }
                          ]}
                          applicant_name={
                            selectedApplication?.firstname +
                            ' ' +
                            selectedApplication?.lastname
                          }
                          applicant_email={
                            selectedApplication?.offered_entrepreneur_email
                          }
                          applicant_phone_no={userProfile?.phone}
                          applicant_address={userProfile?.address}
                          applicant_zipcode={userProfile?.zip_code}
                          applicant_city={userProfile?.city}
                        />
                      )}
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        flexWrap: 'wrap'
                      }}
                    >
                      <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4"></div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: !mobileView && '65%'
                        }}
                      >
                        <div style={{ padding: '0 15px' }}>
                          <p className={classes.previewLabel}>
                            {t('employer.app.fld8')}
                          </p>
                          <p>{t(`employer.application_stt.${statusOffer}`)}</p>
                        </div>
                        {selectedApplication?.application_status ===
                          'Unprocessed application' && (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginTop: 'auto',
                              marginBottom: '10px',
                              padding: '15px'
                            }}
                          >
                            <div>
                              <Button
                                variant="outlined"
                                style={{
                                  fontSize: '12px',
                                  padding: '5px',
                                  marginBottom: mobileView && '5px'
                                }}
                                onClick={rejectWarning}
                                disabled={
                                  selectedApplication?.application_status !==
                                  'Unprocessed application'
                                    ? true
                                    : false
                                }
                              >
                                {t('employer.app.btn1')}
                              </Button>
                              <Button
                                variant="contained"
                                style={{ fontSize: '12px', padding: '5px' }}
                                disabled={
                                  selectedApplication?.application_status !==
                                  'Unprocessed application'
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  offerAssignment(personerData)
                                }}
                              >
                                {t('employer.app.btn2')}
                              </Button>
                            </div>
                          </div>
                        )}
                        {(selectedApplication?.application_status ===
                          'Offer accepted by entrepreneur' ||
                          selectedApplication?.agreement_status_entrepreneur ===
                            'Offer accepted by entrepreneur') &&
                          selectedApplication?.agreement_status_entrepreneur !==
                            'Offer signed' && (
                            <div>
                              <div>
                                <Button
                                  variant="contained"
                                  onClick={handlePreview}
                                  style={{ marginBottom: mobileView && '5px' }}
                                >
                                  <a
                                    href={selectedApplication?.contract_path}
                                    style={{ color: 'white' }}
                                  >
                                    {t('employer.app.btn8')}
                                  </a>
                                </Button>
                                <Tooltip
                                  title={
                                    !isPreview ? (
                                      <p style={{ fontSize: '10px' }}>
                                        {t('employer.app.note1')}
                                      </p>
                                    ) : (
                                      ''
                                    )
                                  }
                                  placement="top"
                                >
                                  <span>
                                    <Button
                                      variant="contained"
                                      style={{ marginLeft: '10px' }}
                                      disabled={!isPreview}
                                      onClick={() => {
                                        signAssignmentPad(selectedApplication)
                                      }}
                                    >
                                      {t('employer.app.btn6')}
                                    </Button>
                                  </span>
                                </Tooltip>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </DialogActions>
                </Dialog>
                <DialogBox
                  classes={classes}
                  isOpen={showRejectWarning}
                  title={t('employer.app.dialogTitle2')}
                  content={t('employer.app.dialogContent1')}
                  buttons={rejectButtons(
                    t,
                    cancelOffer,
                    rejectApplication,
                    selectedApplication?.application_id,
                    selectedApplication?.applied_person_uuid,
                    selectedApplication?.email,
                    selectedApplication?.applied_job_id,
                    selectedApplication,
                    setSelectedApplication
                  )}
                  showCloseButton={false}
                />
                <DialogBox
                  classes={classes}
                  isOpen={isOffer}
                  onClose={() => {
                    cancelOffer()
                  }}
                  title={t('employer.lightEntrepreneurs.dialogTitle1')}
                  content={t('employer.lightEntrepreneurs.dialogContent1')}
                  buttons={isOfferButtons(
                    t,
                    cancelOffer,
                    completeOfferForm,
                    offerToPerson
                  )}
                  showCloseButton={false}
                />

                <Dialog
                  open={isCompleteForm}
                  BackdropProps={{
                    classes: {
                      root: classes.root
                    },
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  fullWidth
                  maxWidth="md"
                >
                  <CloseIcon
                    fontSize="large"
                    onClick={() => openWarningCloseCompleteOfferForm()}
                  />
                  <DialogTitle id="alert-dialog-title">
                    <div
                      style={{
                        textAlign: 'center',
                        color: '#000000',
                        fontSize: '15px'
                      }}
                    >
                      {t('employer.app.dialogTitle1')}
                    </div>
                    <div style={{ color: '#0000008A', textAlign: 'center' }}>
                      <p style={{ fontSize: '14px' }}>
                        <Switch
                          {...label}
                          checked={copyPrevious}
                          onChange={handleSwitchChange}
                        />{' '}
                        {t('employer.lightEntrepreneurs.label4')}
                      </p>
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <div>
                      <ContractFormComponent
                        cancelOffer={cancelOffer}
                        formSubmit={previewContract}
                        setCopyPrevious={setCopyPrevious}
                        openWarningCloseCompleteOfferForm={
                          // action
                          openWarningCloseCompleteOfferForm
                        }
                        closeWarningCloseCompleteOfferForm={
                          closeWarningCloseCompleteOfferForm
                        }
                        openWarningCloseCompleteForm={
                          // state
                          openWarningCloseCompleteForm
                        }
                        formLocation="applicantOffer"
                        showLeItemLoader={showLeItemLoader}
                        enableSendOrSignButton={enableSendOrSignButton}
                        signAndSendContract={signSendContract}
                      />
                    </div>
                  </DialogContent>
                </Dialog>

                {/*Sign the contract*/}
                <Dialog
                  open={signPad}
                  BackdropProps={{
                    classes: {
                      root: classes.root
                    },
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  fullWidth
                  maxWidth="md"
                >
                  <DialogTitle id="alert-dialog-title">
                    <p style={{ textAlign: 'center', color: 'black' }}>
                      {t('employer.lightEntrepreneurs.p3')}
                    </p>
                  </DialogTitle>
                  <DialogContent>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <SignatureCanvas
                        penColor="black"
                        canvasProps={{
                          width: 800,
                          height: 200,
                          className: 'sigCanvas',
                          style: { border: '1px solid black' }
                        }}
                        ref={signPadRef}
                      />
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <div>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          closeSignContractScreen()
                        }}
                      >
                        {t('employer.lightEntrepreneurs.dialogBtn1')}
                      </Button>
                      <Button variant="outlined" onClick={clear}>
                        {t('employer.lightEntrepreneurs.dialogBtn5')}
                      </Button>
                      <Button variant="contained" onClick={trim}>
                        {t('employer.lightEntrepreneurs.dialogBtn6')}
                      </Button>
                    </div>
                  </DialogActions>
                </Dialog>
                <Dialog
                  open={loadSignAndSend}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  BackdropProps={{
                    // Set the background color of the dialog
                    classes: {
                      root: classes.root
                    },
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
                  }}
                >
                  <DialogContent>
                    <DialogContentText
                      id="alert-dialog-description"
                      style={{ fontSize: '15px', margin: '20px' }}
                    >
                      {!isSigned
                        ? t('employer.app.dialogContent2')
                        : t('employer.app.dialogContent3')}
                    </DialogContentText>
                  </DialogContent>
                  <div className={classes.progress}>
                    <LinearProgress />
                  </div>
                </Dialog>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                  }}
                  open={showSnackbar}
                  autoHideDuration={3000}
                  onClose={() => {
                    setSelectedApplication(null)
                    closeApplicationSnackbar()
                  }}
                >
                  <MySnackbarContentWrapper
                    variant="success"
                    message={
                      !isSigned
                        ? t('employer.app.msg1')
                        : t('employer.app.msg3')
                    }
                    onClose={() => {
                      setSelectedApplication(null)
                      closeApplicationSnackbar()
                    }}
                  />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                  }}
                  open={showFailedSnackbar}
                  autoHideDuration={3000}
                  onClose={() => {
                    setSelectedApplication(null)
                    closeApplicationSnackbar()
                  }}
                >
                  <MySnackbarContentWrapper
                    variant="error"
                    message={
                      !isSigned
                        ? t('employer.app.msg2')
                        : t('employer.app.msg4')
                    }
                    onClose={() => {
                      setSelectedApplication(null)
                      closeApplicationSnackbar()
                    }}
                  />
                </Snackbar>
              </>
            )}
            <Dialog
              open={selectedAssignment !== null}
              onClose={() => setSelectedAssignment(null)}
              fullWidth
              maxWidth="md"
            >
              <CloseIcon
                fontSize="large"
                onClick={() => setSelectedAssignment(null)}
              />
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{
                    textAlign: 'center',
                    color: '#000000',
                    fontSize: '15px'
                  }}
                >
                  {t('employer.assignments.h1d')}
                </div>
              </DialogTitle>
              <DialogContent>
                <div>
                  <AssignmentDetails
                    t={t}
                    classes={classes}
                    assignmentType={assignmentType}
                    salaryModel={salaryModel}
                    areaOfWorkDict={areaOfWorkDict}
                    industryRender={industryRender}
                    company_name={companyProfile?.company_name}
                    location={selectedAssignment?.location}
                    amount={selectedAssignment?.amount}
                    contract_salary={selectedAssignment?.contract_salary}
                    unit_price={selectedAssignment?.unit_price}
                    hourly_rate={selectedAssignment?.hourly_rate}
                    weekly_hours={selectedAssignment?.weekly_hours}
                    job_title={selectedAssignment?.job_title}
                    assignment_begins={selectedAssignment?.assignment_begins}
                    assignment_ends={selectedAssignment?.assignment_ends}
                    status={
                      selectedAssignment?.status_assignment
                        ? selectedAssignment?.status_assignment
                        : selectedAssignment?.agreement_status_entrepreneur
                    }
                    industry={selectedAssignment?.industry}
                    last_date_of_application={
                      selectedAssignment?.last_date_of_application
                    }
                    type_of_employment={selectedAssignment?.type_of_employment}
                    notice_period={selectedAssignment?.notice_period}
                    job_description={selectedAssignment?.job_description}
                    enterpreneur_email={selectedAssignment?.enterpreneur_email}
                    lightEntreList={lightEntreList}
                  />
                </div>
              </DialogContent>
            </Dialog>
          </>
        )
      }}
    </Translation>
  )
}

const isOfferButtons = (t, cancelOffer, completeOfferForm, offerToPerson) => {
  return [
    {
      text: t('employer.lightEntrepreneurs.dialogBtn1'),
      onClick: () => cancelOffer(),
      variant: 'outlined'
    },
    {
      text: t('employer.lightEntrepreneurs.dialogBtn2'),
      onClick: (e) => {
        e.preventDefault()
        completeOfferForm(offerToPerson)
      },
      variant: 'contained'
    }
  ]
}

const rejectButtons = (
  t,
  cancelOffer,
  rejectApplication,
  appID,
  uuid,
  email,
  appJobID,
  applicantData,
  setSelectedApplication
) => {
  return [
    {
      text: t('employer.app.btn4'),
      onClick: () => cancelOffer(),
      variant: 'outlined'
    },
    {
      text: t('employer.app.btn5'),
      onClick: () => {
        rejectApplication(appID, uuid, email, appJobID, applicantData)
        setSelectedApplication(null)
      },
      variant: 'contained'
    }
  ]
}

// Format applicantData to match value with contract form
export const applicantDataFormat = (applicantData) => {
  const applicantDataCopy = { ...applicantData }
  applicantDataCopy.content_assignment = applicantDataCopy.job_description
  const salary_model = applicantDataCopy.salary_model
  const assignment_type = applicantDataCopy.assignment_type
  if (
    salary_model === 'hourly_rate' ||
    (salary_model === 'commission' && assignment_type === 'until_completion')
  ) {
    applicantDataCopy.amount = applicantDataCopy.hourly_rate
  } else if (
    salary_model === 'contract_price' &&
    (assignment_type === 'temporary_with_notice' ||
      assignment_type === 'until_completion')
  ) {
    applicantDataCopy.amount = applicantDataCopy.contract_salary
  } else if (
    salary_model === 'unit_price' &&
    (assignment_type === 'temporary_with_notice' ||
      assignment_type === 'until_completion')
  ) {
    applicantDataCopy.amount = applicantDataCopy.unit_price
  }
  applicantDataCopy.assignment_ends =
    applicantDataCopy.assignment_type !== 'temporary'
      ? null
      : applicantDataCopy.assignment_ends
  return applicantDataCopy
}

export default withStyles(styles)(ApplicationRow)
